import { RestManager } from '@/newApi/services/rest/RestManager';
import { getApiHost } from '@/appSettings';
import type { ReportResponse, CreateSalaryReviewKeyFiguresReportParams } from '@sysarb/sysarb-types-v2/services/v1/pay-management/';
import { useLoginStore } from '@/login/stores/useLoginStore';

const payManagementService = new RestManager(`https://${getApiHost()}/pay-management-service`);

export function abort(): void {
    payManagementService.abort();
}

/**
 * Get list of SalaryReviewEmployments the current user has access to
 * @param salaryReviewId The id of the salary review
 */
export async function createSalaryReviewKeyFiguresReport(data: CreateSalaryReviewKeyFiguresReportParams): Promise<ReportResponse | null> {
    const { instance } = useLoginStore();
    return payManagementService.post<ReportResponse>(data, `v1/${instance}/pay-management/review/createSalaryReviewKeyFigures`);
}
